<template>
    <div>
        <h4>{{ Date.now() | moment('Do MMMM Y') }}</h4>

        <b-form-select
            v-model="form.type"
            size="sm"
            :options="commentTypes"
            class="mb-1"
        >
            <template #first>
                <b-form-select-option :value="null" disabled>
                    -- Sélectionner le type --
                </b-form-select-option>
            </template>
        </b-form-select>
        <b-form-textarea
            v-model="form.description"
            rows="2"
            max-rows="6"
            class="mb-3"
        />
        <b-button variant="success" size="sm" @click="saveEvent">
            <i class="far fa-save fa-fw"></i
            ><span class="ml-1">Enregistrer</span>
        </b-button>
        <b-button variant="secondary" size="sm" @click="close">
            <i class="far fa-times fa-fw"></i><span class="ml-1">Annuler</span>
        </b-button>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'HistoryElementCreate',

    props: {
        defaultCommentType: null,
    },

    data() {
        return {
            form: {},
        }
    },

    created() {
        this.form.type = this.defaultCommentType
    },

    methods: {
        async saveEvent() {
            try {
                this.form.client_id = this.clientId
                await axios.post('/clientEvents/event', this.form)
                this.$store.commit('browsing/RESET_CREATING')
                this.$parent.getItems()
            } catch (error) {
                console.log(error)
            }
        },

        close() {
            this.$store.commit('browsing/RESET_CREATING')
        },
    },

    computed: {
        ...mapState({
            clientId: (state) => state.browsing.clientId,
            commentTypes: (state) => state.data.options.commentTypes,
        }),
    },
}
</script>

<style scoped>
.comment-description {
    margin-bottom: 0;
}

.comment-created {
    font-size: 11px;
    margin-bottom: 0;
}
</style>
